
import { UserManager, WebStorageStateStore } from "oidc-client-ts";

const baseUrl = window.location.origin;
const apiUrl = "__API_URL__";

export const userManager = new UserManager({
  authority: `${apiUrl}/proarc-sts`,
  client_id: "ANNORAIL",

  redirect_uri: `${baseUrl}/callback`,
  post_logout_redirect_uri: `${baseUrl}/annorail/*`,

  response_type: "code",

  // ✅ IMPORTANT
  scope: "openid profile offline_access",

  // ✅ disable iframe-based renew
  automaticSilentRenew: true,
  monitorSession: false,

  // ✅ use refresh tokens instead
  // (handled automatically when offline_access is granted)

  userStore: new WebStorageStateStore({
    store: window.localStorage
  })
});
